import { ApiData } from 'types/api';

export function isSuccessResult<T extends ApiData<unknown>>(res: T | Error[]): res is T {
  return res.hasOwnProperty('data');
}
